import { DiceRoll } from "../utils/dice";
import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="attribute-random-roller"
export default class extends Controller {
	static targets = ["attribute"];
	static values = {
		dice: {
			type: String,
			default: "3d6",
		},
		auto: {
			type: Boolean,
			default: false,
		},
	};
	static outlets = ["attribute-modifier"];

	connect() {
		// Auto-roll on load only when explicitly enabled and no
		// values are set yet, so we never clobber existing attributes (e.g. retainer edit).
		// Modifiers are skipped here because the attribute-modifier outlets aren't connected
		// yet on first load; each one recalculates on its own connect().
		if (this.autoValue && this.attributeTargets.every((attribute) => attribute.value === "")) {
			this.roll({ params: { skipModifiers: true } });
		}
	}

	roll(event) {
		this.attributeTargets.forEach((attribute) => {
			attribute.value = new DiceRoll(this.diceValue).total;
		});

		if (event?.params?.skipModifiers !== true) {
			this.calculateModifiers();
		}
	}

	// Recalculate all attribute modifiers
	calculateModifiers() {
		this.attributeModifierOutlets.forEach((outlet) => {
			outlet.calculate();
		});
	}

	reset() {
		this.attributeTargets.forEach((attribute) => {
			attribute.value = "";
		});

		this.roll();
	}
}
